import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { LandingPage } from 'cpfr-common';
import { fetchLandingPage } from './LandingPageSlice';
import { LandingPageContentSelector } from './LandingPageContentSelector';

export function useLandingPage(): AbstractContentState<LandingPage> {
    return useCmsContent(fetchLandingPage, LandingPageContentSelector);
}
